export const intercomConfig = {
  appId: process.env.VUE_APP_INTERCOM_APP_ID,
};

window.intercomSettings = {
  app_id: process.env.VUE_APP_INTERCOM_APP_ID,
};

export const isIntercomEnabled = process.env.VUE_APP_INTERCOM === 'true';
